import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import Input from '../../Components/Input/Input';
import Button from '../../Components/Button/Button';
import { handleValidationErrors, validateForm } from '../../Utils/validationHelper';
import { postApi } from '../../Services/apiService';
import { toast } from 'react-toastify';

const ForgotPassword = () => {
  const [formData, setFormData] = useState({
    email: '',
  });
  const [errors, setErrors] = useState({});
  const emailRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    // Add animation classes on mount
    const infoSection = document.querySelector('.signup-info');
    const formSection = document.querySelector('.login-form-section');
    const formCard = document.querySelector('.login-form-card');
    
    if (infoSection) infoSection.classList.add('animate-fade-in-left');
    if (formSection) formSection.classList.add('animate-fade-in-right');
    if (formCard) formCard.classList.add('animate-scale-in');
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    let newValue = value;

    // Prevent leading spaces for email input
    if (name === 'email') {
      if (newValue.startsWith(' ')) {
        newValue = newValue.trimStart();
      }
    }

    setFormData((prev) => ({ ...prev, [name]: newValue }));
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: '' }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Define validation rules
    const validationRules = {
      email: {
        required: true,
        pattern: /\S+@\S+\.\S+/,
        message: {
          required: 'Email is required',
          pattern: 'Email is invalid',
        },
      },
    };

    // Validate the form
    const newErrors = validateForm(formData, validationRules);

    // Handle errors (will focus on first error input)
    const inputRefs = { email: emailRef };
    if (handleValidationErrors(newErrors, inputRefs, setErrors)) {
      return;
    }

    setIsLoading(true);
    setErrors({});

    try {
      const response = await postApi('/auth/forgot-password', {
        email: formData.email,
      });

      if (response?.statusCode === 200) {
        toast.success(response?.message || 'Password reset email sent successfully');
        // Optionally clear the form after successful request
        setFormData({ email: '' });
      } else {
        const errorMessage = response?.message || 'Unable to send password reset email. Please try again.';
        toast.error(errorMessage);
        setErrors({ submit: errorMessage });
      }
    } catch (error) {
      const errorMessage = error?.response?.data?.message || error?.message || 'Unable to send password reset email. Please try again.';
      toast.error(errorMessage);
      setErrors({ submit: errorMessage });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="signup-info">
          <div className="signup-logo">
            <Link to="/" onClick={() => localStorage.clear()}>
              <img src={window.getPublicUrl("/assets/images/Logo.png")} alt="ClearRent" className="signup-logo-img" />
            </Link>
          </div>
          <h1 className="signup-title">Simplifying tenant Screening for landlords</h1>
          <p className="signup-subtitle">
            Create your account and get instant access to automated tenant screening.
          </p>
          <ul className="signup-features">
            <li>
              <img src={window.getPublicUrl("/assets/images/CircleCheckWIthBackground.svg")} alt="Check" className="signup-feature-icon" />
              <span>Unlimited property listings</span>
            </li>
            <li>
              <img src={window.getPublicUrl("/assets/images/CircleCheckWIthBackground.svg")} alt="Check" className="signup-feature-icon" />
              <span>Automated voice interviews & document verification</span>
            </li>
            <li>
              <img src={window.getPublicUrl("/assets/images/CircleCheckWIthBackground.svg")} alt="Check" className="signup-feature-icon" />
              <span>Automated reference checks</span>
            </li>
          </ul>
        </div>
        <div className="login-form-section">
          <h2 className="login-form-title">Forgot Password</h2>
          <p className="login-form-subtitle">
            Enter your email address and we'll send you a link to reset your password
          </p>
          <form onSubmit={handleSubmit} className={`login-form-card ${Object.keys(errors).length > 0 ? 'has-errors' : ''}`} noValidate>
            <div className="login-form-header">Account Information</div>
            <div className={`login-form-fields ${Object.keys(errors).length > 0 ? 'has-errors' : ''}`}>
              <Input
                ref={emailRef}
                type="email"
                name="email"
                label="Email"
                placeholder="Eg. JohnDey4533@gmail.com"
                value={formData.email}
                onChange={handleChange}
                error={errors.email}
                required
              />
            </div>
            {errors.submit && (
              <div className="error-message-container has-error" style={{ marginBottom: '1rem' }}>
                <span className="error-message">{errors.submit}</span>
              </div>
            )}
            <Button type="submit" variant="success" className="login-submit-button" disabled={isLoading}>
              {isLoading ? 'Sending...' : 'Continue'}
            </Button>
            <p className="login-signup-link">
              Remember your password? <Link to="/login">Sign in</Link>
            </p>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
